<article>
	<header>
		<h3>
			{{ 'adminstat.common.conversion_source' | translate }}
		</h3>
	</header>
	
	<section>
		<cache-date></cache-date>
	</section>
	
	<section>
		<nav class="nav nav-pills flex-column flex-sm-row">
			<ng-container *ngFor="let yyyy of years">
				<a
					[class]="yyyy == year ? 'period-tab flex-sm-fill text-sm-center nav-link active' : 'period-tab flex-sm-fill text-sm-center nav-link'"
					[routerLink]="['/' + baseUrl]"
					[queryParams]="getQueryParams({year: yyyy})"
					[attr.tab]="yyyy"
					[sextant]="'period'"
				>
					{{ yyyy }}
				</a>
			</ng-container>
		</nav>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
		<hr/>
	</section>
	
	<section>
		<chart
			[data]="chart2.data"
			[options]="chart2.options"
			[sextant]="'chart2'">
			>
		</chart>
		
		<hr/>
	</section>
	
	<section>
		<h3>
			Конверсия по источникам
		</h3>
		
		<form>
			<div class="form-row">
				<div class="form-group col-md-6">
					<div
						class="form-check"
						*ngFor="let radio of ['usersWithSite', 'usersWithOrNotSite']"
					>
						<label>
							<input
								type="radio"
								[(ngModel)]="filter.filterParams.userRegType"
								[ngModelOptions]="{standalone: true}"
								[value]="radio" [checked]="filter.filterParams.userRegType == radio"
								(change)="userRegTypeChange()"
							>
							
							{{ 'adminstat.filterForm.' + radio | translate }}
						</label>
					</div>
				</div>
				<div class="form-group col-md-6">
					<div class="form-group">
						<label for="user21billingEnd">
							{{ 'adminstat.filterForm.user21billingEnd' | translate }}
						</label>
						
						<input
							type="number"
							class="form-control"
							id="user21billingEnd"
							[(ngModel)]="filter.filterParams.user21billingEnd"
							[ngModelOptions]="{standalone: true}"
							(change)="onChangeBillingEnd()"
						/>
					</div>
				</div>
				
			</div>
		</form>
	</section>
	
	<section>
		<div class="alert alert-success" role="alert">
			<ul>
				<li>
					Конверсия считается в процентах, как "{{ 'adminstat.filterForm.' + filter.filterParams.userRegType | translate }}" / "Кол-платников"
				</li>
				
				<li>
					Сортировка по убыванию регистраций за весь год
				</li>
				
				<li>
					Учитываются первые ручные оплаты головы, т.е. оплаты за 21 день с даты создания.
				</li>
			</ul>
		</div>
		
		<loading [isLoad]="statsLoader"></loading>
		
		<button class="btn btn-outline-success btn-sm" type="button" (click)="downloadStats()">
			<i aria-hidden="true" class="fa fa-file-excel">
				<a href="#"></a>
			</i>
		</button>
		
		<table class="table" [sextant]="'table'">
			<thead class="fixed_header">
				<tr class="table-primary">
					<th>
						
					</th>
					
					<th *ngFor="let columnName of columnNames">
						{{ columnName | dateFormat:'MMMM' }}
					</th>
				</tr>
			</thead>
			
			<tbody>
				<tr
					*ngFor="let group of stats"
					[ngClass]="getRowClass(group)"
				>
					<td
						(click)="onClickByGroup(group)"
						[ngClass]="group.parent ? 'pl-5' : ''"
						style="cursor: pointer;"
					>
						{{ group.rowName }}
						
						<loading [isLoad]="group._isLoad"></loading>
					</td>
					
					<td
						*ngFor="let column of group.columns"
					>
						<div
							[ngbTooltip]="ceilTooltip"
							container="body"
						>
							<ng-template #ceilTooltip>
								100 * {{ column.data.userPaidCount }} / {{ column.data.userCount }} =
								{{ column.data.conversion | numberFormat: '1.2-2' }}
							</ng-template>
							
							{{ column.data.conversion | numberFormat: '1.2-2' }}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</section>

	<section>
		<h3>
			Основные источники
		</h3>
		<chart
			[data]="chart.data"
			[options]="chart.options"
			[sextant]="'chart'">
			>
		</chart>
		
		<hr/>
		
		<h3>
			Мелкие и остальные источники
		</h3>
		<chart
			[data]="chartSmallSource.data"
			[options]="chartSmallSource.options"
			[sextant]="'chartSmallSource'">
		></chart>
		
		<hr/>
	</section>
	
	<section>
		<h3>
			Регистрации по источникам
		</h3>
		
		<loading [isLoad]="statsLoader"></loading>
		
		<table class="table" [sextant]="'table2'">
			<thead class="fixed_header">
			<tr class="table-primary">
				<th>
				
				</th>
				
				<th *ngFor="let columnName of columnNames">
					{{ columnName | dateFormat:'MMMM' }}
				</th>
			</tr>
			</thead>
			
			<tbody>
			<tr
				*ngFor="let group of stats"
				[ngClass]="getRowClass(group)"
			>
				<td
					(click)="onClickByGroup(group)"
					[ngClass]="group.parent ? 'pl-5' : ''"
					style="cursor: pointer;"
				>
					{{ group.rowName }}
					
					<loading [isLoad]="group._isLoad"></loading>
				</td>
				
				<td
					*ngFor="let column of group.columns"
				>
					{{ column.data.userCount }}
				</td>
			</tr>
			</tbody>
		</table>
		
		<hr/>
	</section>
	
	<section>
		<chart
			[data]="tableChart.data"
			[options]="tableChart.options"
			[sextant]="'tableChart'">
			></chart>
		<hr/>
	</section>
</article>
